import { render, staticRenderFns } from "./TypeRadioControl.vue?vue&type=template&id=fb45fcb0&scoped=true&"
import script from "./TypeRadioControl.vue?vue&type=script&lang=js&"
export * from "./TypeRadioControl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb45fcb0",
  null
  
)

export default component.exports